module.exports = __webpack_public_path__ + "img/Pano_2.30bc16de.jpg";